var _a;
import { createSlice, nanoid } from '@reduxjs/toolkit';
var initialState = {};
var chatSlice = createSlice({
    name: 'chat',
    initialState: initialState,
    reducers: {
        updateConversationId: function (state) {
            state.conversation_id = nanoid();
        },
        setConversationId: function (state, action) {
            state.conversation_id = action.payload;
        },
        setUnInitializedConversationId: function (state, action) {
            state.uninitialized_conversation_id = action.payload;
        }
    }
});
export var updateConversationId = (_a = chatSlice.actions, _a.updateConversationId), setConversationId = _a.setConversationId, setUnInitializedConversationId = _a.setUnInitializedConversationId;
export default chatSlice.reducer;
